import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import { TableSearchBar } from "./search-bar/table-search-bar";
import { AddUserAccount } from "./add-user-account";
import { getUsers, apiUser } from "../../../api/api-users";
import { emitter } from "../../../common/utils/emitter";
import { alert } from "../../../common/utils/alert";

export class UserAccountTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isAddUser: false,
      typeOption: "create_new",
      exportFilter: {
        branch: null,
        code: null,
        created_by: {
          name: null,
        },
        department: null,
        name: null,
        active: null,
      },
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Tên tài khoản",
        dataIndex: "name",
        key: "name",
        render: (name) => (
          <div style={{ minWidth: 200, maxWidth: 250, textAlign: "left" }}>
            {name}
          </div>
        ),
      },
      {
        title: "Mã NV",
        dataIndex: "code",
        key: "code",
        render: (data) => <div style={{ textAlign: "right" }}>{data}</div>,
      },
      {
        title: "Khu vực",
        dataIndex: "branch",
        key: "branch",
        render: (item) => (
          <div style={{ minWidth: 80 }}>{item ? item.name : ""}</div>
        ),
      },
      {
        title: "Vai trò",
        dataIndex: "user_role",
        key: "user_role",
        render: (item) => <div style={{ minWidth: 80 }}>{item.name}</div>,
      },
      {
        title: "Bộ phận",
        dataIndex: "department",
        key: "department",
        render: (item) => (
          <div style={{ minWidth: 110 }}>{item ? item.name : ""}</div>
        ),
      },
      {
        title: "Trạng thái",
        dataIndex: "active",
        key: "active",
        render: (active) => (
          <div style={{ minWidth: 80 }}>{active ? "Active" : "Inactive"}</div>
        ),
      },
      {
        title: "Người tạo",
        dataIndex: "created_by",
        key: "created_by",
        render: (created_by) => (
          <div style={{ minWidth: 100 }}>{created_by.name}</div>
        ),
      },
      {
        title: "Ngày tạo",
        dataIndex: "created_at",
        key: "created_at",
        render: (created_at) => (
          <div style={{ minWidth: 100 }}>
            {moment(created_at).format("DD/MM/YYYY")}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "id",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.handleAddUser(true, "show_detail", data);
  };

  handleAddUser = (status, type, data) => {
    this.setState({ isAddUser: status, typeOption: type }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        this.addUsers.updateFormUser(data);
      }
      if (!status) {
        this.getData(1);
      }
    });
  };

  getData = async (page) => {
    const { state } = this.search;
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    if (state.checkSearch) {
      this.setState({
        exportFilter: {
          branch: state.branch
            ? {
                code: state.branch,
              }
            : null,
          code: state.employee_id
            ? `%${state.employee_id
                .trim()
                .replace(/(\r\n|\n|\r)/gm, " ")
                .replace(/%/gi, "\\%")}%`
            : null,
          created_by: {
            name: state.created_person
              ? `%${state.created_person
                  .trim()
                  .replace(/(\r\n|\n|\r)/gm, " ")
                  .replace(/%/gi, "\\%")}%`
              : null,
          },
          created_at: state.created_date ? state.created_date : null,
          department: state.department
            ? {
                id: state.department,
              }
            : null,
          name: state.account_name
            ? `%${state.account_name
                .trim()
                .replace(/(\r\n|\n|\r)/gm, " ")
                .replace(/%/gi, "\\%")}%`
            : null,
          active: state.account_status
            ? state.account_status === 1
              ? true
              : false
            : null,
          user_role: {
            id_in: state.role ? (state.role === 1 ? [1] : [2]) : [1, 2],
          },
        },
      });
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiUser.getUsers(this.state.exportFilter, page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.totalElements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page, false);
  };

  render() {
    const { dataTable, total, isAddUser, typeOption } = this.state;
    return (
      <div className="contract-table">
        {!isAddUser ? (
          <>
            <div
              style={{
                color: "#d20a30",
                paddingTop: "20px",
                fontSize: "1em",
                display: "flex",
                alignItems: "center",
              }}
            >
              Tài khoản người dùng
            </div>
            <TableSearchBar
              search={this.getData}
              ref={(ref) => (this.search = ref)}
            />
            <Table
              rowKey={(record) => record.customer_id}
              style={{ width: "100%" }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleAddUser(true, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm tài khoản
              </Button>
            </div>
          </>
        ) : (
          <AddUserAccount
            typeOption={typeOption}
            ref={(ref) => (this.addUsers = ref)}
            close={() => this.handleAddUser(false)}
          />
        )}
      </div>
    );
  }
}
